import React, {useEffect, useState} from 'react'
//! Styles
import './order-choose.style.css'
// Images
import BasketIcon from '../../assets/images/icons/basket-icon.png'
// Actions
import {Base_API} from '../../_actions/matcher'

function ChooseOrder({pageDetail, refCampaign, type}) {

    const [showPromotion, setShowPromotion] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0)
    const [qttSelected, setQttSelected] = useState(0); 

    useEffect(() => {
        //console.log(quantitySelected);
        //console.log(document.querySelector('.odch-container').offsetHeight);
        document.querySelector('.appm-pck-space').style.height = `${document.querySelector('.odch-container').offsetHeight}px`;
    })

    const handleSubmitOrder = () => {
        if(type === 'packages')
        {
            window.location.href = `${Base_API.pathWeb}/n-health/my-basket/${refCampaign}`;
        }else
        {
            window.location.href = `${Base_API.pathWeb}/n-health/my-basket-nhservices/${refCampaign}`;
        }

        // window.localStorage.setItem('total_price', totalPrice);
        // window.localStorage.setItem('package_selected', JSON.stringify(packOrder));
    }

    return (
        <div className="odch-container">
            {/* button submit */}
            <button 
                className={pageDetail.totalAmount > 0 ? "odch-submit_btn" : "odch-submit_btn disabled"}
                onClick={pageDetail.totalAmount > 0 ? handleSubmitOrder : null} 
            >
                <div className="left">
                    <img src={BasketIcon} />
                    {pageDetail.totalAmount} รายการ
                </div>
                <div className="right">
                    <h3 className="total-price">฿{pageDetail.totalPrice}</h3>
                </div>
            </button>
        </div>
    )
}

export default ChooseOrder